var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectIcon16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.39535 1.16267V3.48825H3.72093V1.16267H1.39535ZM17.4419 15.1241C16.7997 15.1241 16.2791 15.6447 16.2791 16.2869C16.2791 16.9291 16.7997 17.4497 17.4419 17.4497C18.0841 17.4497 18.6047 16.9291 18.6047 16.2869C18.6047 15.6447 18.0841 15.1241 17.4419 15.1241Z",
    fill: "white",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H5.11628V1.86047H6.4004C7.29947 1.86047 8.02831 2.5893 8.02831 3.48837V15.7283C8.02831 15.8567 8.13243 15.9608 8.26087 15.9608H13.3459L11.659 14.0336C11.4053 13.7436 11.4346 13.3028 11.7245 13.0491C12.0145 12.7953 12.4552 12.8246 12.709 13.1146L15.0053 15.7381C15.3356 14.7075 16.3016 13.9614 17.4419 13.9614C18.8547 13.9614 20 15.1067 20 16.5196C20 17.9324 18.8547 19.0777 17.4419 19.0777C16.3612 19.0777 15.437 18.4076 15.0622 17.4602L12.6722 19.8008C12.3969 20.0704 11.9552 20.0658 11.6856 19.7905C11.416 19.5152 11.4206 19.0735 11.6959 18.8039L13.1742 17.3562H8.26087C7.3618 17.3562 6.63296 16.6273 6.63296 15.7283V3.48837C6.63296 3.35993 6.52884 3.25581 6.4004 3.25581H5.11628V5.11628H0V0ZM1.39535 1.39535V3.72093H3.72093V1.39535H1.39535ZM17.4419 15.3568C16.7997 15.3568 16.2791 15.8774 16.2791 16.5196C16.2791 17.1617 16.7997 17.6823 17.4419 17.6823C18.0841 17.6823 18.6047 17.1617 18.6047 16.5196C18.6047 15.8774 18.0841 15.3568 17.4419 15.3568Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectIcon16);
export default __webpack_public_path__ + "static/media/project-icon16.b36263bf29f068ab4c3fda3f0421ccff.svg";
export { ForwardRef as ReactComponent };